<template>
  <div>
    <el-table
        ref="tableStudent"
        element-loading-spinner="el-icon-loading"
        :data="responseDataStudents"
        border
        :max-height="$tableMaxHeight"
        :header-cell-style="headerCellStyle"
        :element-loading-text="$tableLoading"
        @selection-change="handleSelectionChange"
        element-loading-background="rgba(255,255,255, 0)"
        v-loading="isLoading"
        :summary-method="getSummaries"
        show-summary
    >
      <el-table-column
          fixed="left"
          type="selection"
          width="50"
          align="center"
      />

      <el-table-column
          fixed="left"
          type="index"
          label="STT"
          width="50"
          align="center"
      />

      <el-table-column
          fixed="left"
          label="Họ và tên"
          width="200"
      >
        <template v-slot:default="scope">
          <el-tooltip placement="top">
            <div slot="content">
              Mã học sinh: {{ scope.row.kidCode }}
              <br>
              Bố/Mẹ: {{ scope.row.fatherPhone }} - {{ scope.row.motherPhone }}
            </div>
            <span>{{ scope.row.fullName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Biệt danh"
          width="100"
          align="center"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.nickName }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Hiển thị"
          width="80"
          align="center"
      >
        <template v-slot:default="scope">
          <el-checkbox
              v-model="scope.row.orderHidden"
              @change="(value) => handelShowOrHidden(scope.row, value)"
              :disabled="
              scope.row.status === null || scope.row.status === 'Ẩn hóa đơn'
            "
          ></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column
          label="Thông tin bổ sung"
          width="100"
          align="center"
      >
        <template v-slot:default="scope">
          <!--     Cho lớp     -->
          <el-button
              v-if="scope.row.category === 'CLASS'"
              size="mini"
              @click="handleOpenKidDetail(scope.row, scope.row.status)"
          ><i class="el-icon-document"></i
          ></el-button>

          <!--     Cho nhóm     -->
          <el-button
              v-if="scope.row.category === 'GROUP'"
              size="mini"
              @click="handleOpenKidGroupDetail(scope.row, scope.row.status)"
          ><i class="el-icon-document"></i
          ></el-button>
        </template>
      </el-table-column>

      <el-table-column
          label="Loại học phí"
          width="100"
          align="center"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.category === "CLASS" ? "Lớp" : "Nhóm" }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Tháng tồn"
          width="80"
          align="center"
      >
        <template v-slot:default="scope">

          <!--     Cho lớp     -->
          <div v-if="scope.row.category === 'CLASS'">
            <el-button
                class="click-in-row"
                type="text"
                @click="inventoryOrder(scope.row)"
                v-if="scope.row.numPayLate !== 0"
            >
              {{ scope.row.numPayLate }}
            </el-button>
          </div>

          <!--     Cho nhóm     -->
          <div v-if="scope.row.category === 'GROUP'">
            <el-button
                class="click-in-row"
                type="text"
                @click="inventoryOrderGroup(scope.row)"
                v-if="scope.row.numPayLateGroup !== 0"
            >{{ scope.row.numPayLateGroup }}
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column
          label="Tên gói"
          width="100"
          align="center"
      >
        <template v-slot:default="scope">
        <span >{{scope.row.namePackage}}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Gia hạn gói"
          width="80"
          align="center"
      >
        <template v-slot:default="scope">
          <el-checkbox
              v-model="scope.row.checkStatus"
              @change="(value) => handelRegisterPackage(scope.row, value)"
          ></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column
          label="Trạng thái gói"
          width="100"
          align="center"
      >
        <template v-slot:default="scope">
          <span v-if="scope.row.tuitionStatus === 'Còn hạn'" style="color: #409EFF">{{ scope.row.tuitionStatus }}</span>
          <span v-else style="color: #F56C6C">{{ scope.row.tuitionStatus }}</span>
        </template>
      </el-table-column>


      <el-table-column
          label="Ngày còn lại"
          width="80"
          align="center"
      >
        <template v-slot:default="scope">
          <el-tooltip placement="top">
            <div slot="content">
              Thời gian gói: {{ formatDateTime(scope.row.startDate) }} đến {{ formatDateTime(scope.row.endDate) }}
            </div>
            <span>{{ scope.row.remainDay }}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Trạng thái"
          width="150"
          align="center"
      >
        <template v-slot:default="scope">
          <div :class="getStatusColor(scope.row.status)">
            {{ getStatusValue(scope.row.status) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
          label="Chuyển thanh toán"
          width="140"
          align="center"
      >
        <template v-slot:default="scope">
          <span v-if="scope.row.transactionEntry==='MONEY_WALLET'&& scope.row.afterMoney !==0" style="color: orange ">Không chuyển</span>
          <span v-if="scope.row.transactionEntry==='MONEY_MONTH'&& scope.row.afterMoney !==0" style="color: blue ">Sang tháng sau</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Thiếu/thừa tháng trước"
          width="110"
          align="right"
          prop="beforeMoney"
      >
        <template v-slot:default="scope">
          {{ scope.row.beforeMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          label="Phải thu tháng này"
          width="110"
          align="right"
          prop="sumMoney"
      >
        <template v-slot:default="scope">
          {{ scope.row.sumMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          label="Đã thu"
          width="110"
          align="right"
          prop="collectedMoney"
      >
        <template v-slot:default="scope">
          <!--     Cho lớp     -->
          <div v-if="scope.row.category === 'CLASS'">
            <el-button
                v-if="getStatusValue(scope.row.status) !=='Chưa có hóa đơn'"
                class="click-in-row"
                type="text"
                @click="collectedMoneyMethod(scope.row, scope.row.status)">
              <div>
                <span v-if="scope.row.collectedMoney">{{ scope.row.collectedMoney | formatCurrency }}</span>
                <span v-else><b>-</b></span>
              </div>
            </el-button>
          </div>

          <!--     Cho nhóm     -->
          <div v-if="scope.row.category === 'GROUP'">
            <el-button
                v-if="getStatusValue(scope.row.status) !=='Chưa có hóa đơn'"
                class="click-in-row"
                type="text"
                @click="collectedMoneyGroupMethod(scope.row, scope.row.status)">
              <div>
                <span v-if="scope.row.collectedMoney">{{ scope.row.collectedMoney | formatCurrency }}</span>
                <span v-else><b>-</b></span>
              </div>
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column
          label="Tiền mặt"
          width="110"
          align="right"
          prop="cashMoney"
      >
        <template v-slot:default="scope">
          {{ scope.row.cashMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          label="Chuyển khoản"
          width="120"
          align="right"
          prop="transferMoney"
      >
        <template v-slot:default="scope">
          {{ scope.row.transferMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          label="Thiếu/thừa còn lại"
          width="110"
          align="center"
          prop="afterMoney"
      >
        <template v-slot:default="scope">
          {{ scope.row.afterMoney | formatCurrency }}
        </template>
      </el-table-column>

      <el-table-column
          v-for="(item, index) in courseNames"
          :key="index"
          align="right"
          width="115"
          :label="item"
      >
        <template v-slot:default="scope">
          <el-tooltip :content="scope.column.label" placement="top">
            <span @click="changeNameRevenus(item.name)" style="cursor: pointer;">{{ item.name }}</span>
          </el-tooltip>

          <!--     Cho lớp     -->
          <div v-if="scope.row.category === 'CLASS'">
            <div v-if="getStatusValue(scope.row.status) !=='Chưa có hóa đơn'">
              <el-button
                  class="click-in-row"
                  type="text"
                  @click="getDetailKT(getDataIndexKt(scope.row, scope.column.label), scope.row, scope.column.label, scope.row.status)"
              >
                <span> {{ showDataListKt(scope.row, scope.column.label) | formatCurrency }}</span>
              </el-button>
            </div>
          </div>

          <!--     Cho nhóm     -->
          <div v-if="scope.row.category === 'GROUP'">
            <div v-if="getStatusValue(scope.row.status) !=='Chưa có hóa đơn'">
              <el-button
                  class="click-in-row"
                  type="text"
                  @click="getDetailKTGroup(getDataIndexKt(scope.row, scope.column.label), scope.row, scope.column.label, scope.row.status)"
              >
                <span> {{ showDataListKt(scope.row, scope.column.label) | formatCurrency }}</span>
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
          fixed="right"
          label="Tác vụ"
          width="215"
          align="center"
      >
        <template v-slot:default="scope">

          <!--     Tác vụ cho học sinh lớp     -->
          <div
              v-if="scope.row.category === 'CLASS'"
              style="display: flex; justify-content: center"
          >
            <el-button style="display: none"></el-button>
            <!--           giữ nút này do lỗi framework k cập nhật, check được :disable(thanh toán) khi render giao diện-->

            <!--     Thanh toán cho học sinh lớp       -->
            <el-button
                size="mini"
                :type="getButtonCashierType(scope.row)"
                @click="orderKidsCashierMethod(scope.row)"
                :disabled="scope.row.status === null || scope.row.status === 'Ẩn hóa đơn'|| scope.row.sumMoney === 0"
            >
              Thanh toán
            </el-button>

            <!--   Lịch sử cho học sinh lớp   -->
            <el-button
                type="success"
                size="mini"
                @click="orderKidsHistoryMethod(scope.row)"
                :disabled="scope.row.status === null|| scope.row.sumMoney === 0"
            >
              Lịch sử
            </el-button>
          </div>

          <!--     Tác vụ cho học sinh nhóm     -->
          <div
              v-if="scope.row.category === 'GROUP'"
              style="display: flex; justify-content: center"
          >
            <el-button style="display: none"></el-button>
            <!--           giữ nút này do lỗi framework k cập nhật, check được :disable(thanh toán) khi render giao diện-->

            <!--     Thanh toán cho học sinh nhóm      -->
            <el-button
                size="mini"
                :type="getButtonCashierType(scope.row)"
                @click="orderKidsCashierGroupMethod(scope.row)"
                :disabled="scope.row.status === null || scope.row.status === 'Ẩn hóa đơn'|| scope.row.sumMoney === 0"
            >Thanh toán
            </el-button>

            <!--   Lịch sử cho học sinh nhóm   -->
            <el-button
                type="success"
                size="mini"
                @click="orderKidsHistoryGroupMethod(scope.row)"
                :disabled="scope.row.status === null|| scope.row.sumMoney === 0"
            >
              Lịch sử
            </el-button>
          </div>
        </template>
      </el-table-column>

      <template #empty>
        <div style="text-align: center; font-size: 16px; color: #43a0ff;">
          <i class="el-icon-warning"></i>
          <span> Không có dữ liệu! </span>
        </div>
      </template>
    </el-table>

    <!--  LỚP  -->
    <OrderKidsExcelCashier
        :isOpenCashierDialog="isDialog.showOrderKidsExcelCashierDialog"
        @dialog-close="closeOrderKidsExcelCashierDialog"
        :isActivatedAccount="isActivatedAccount"
        ref="OrderKidsExcelCashier"
    />

    <HistoryOrderKidsDialog
        :isOpenHistoryDialog="isDialog.showHistoryDialog"
        @closeHistoryOrderKids="closeOrderKidsHistoryDialog()"
        ref="OrderKidsHistoryDialog"
    />

    <DetailKTDialog
        :isOpenDetailKT="isDialog.showDetailKtDialog"
        @closeDetailKT="closeDetailKTDialog"
        ref="DetailKTDialog"
    />

    <ExcelKidDetail
        :isOpenKidDetail="isDialog.showKidDetailDialog"
        :kids-detail-data="kidDetailData"
        @closeDetailKid="handleCloseDetailKid"
        ref="ExcelKidDetail"
    />

    <InventoryOrderDialog
        :isOpenInventoryOrder="isDialog.showInventoryOrder"
        @closeInventoryOrder="closeInventoryOrderDialog"
        ref="InventoryOrderDialog"
    />

    <CollectedMoneyDialog
        v-if="checkPermission(['fees_2_excel_cash_payment'])"
        :isOpenCollectedMoney="isDialog.showCollectedMoney"
        @closeCollectedMoney="closeCollectedMoneyDialog"
        ref="CollectedMoneyDialog"
    />

    <!--  NHÓM  -->
    <OrderKidsExcelCashierGroup
        :isOpenCashierDialog="isDialog.showOrderKidsExcelCashierGroupDialog"
        @dialog-close="closeOrderKidsExcelCashierGroupDialog"
        :isActivatedAccount="isActivatedAccount"
        ref="OrderKidsExcelCashierGroup"
    />

    <HistoryOderKidsDialogGroup
        :isOpenHistoryDialogGroup="isDialog.showHistoryGroupDialog"
        @closeHistoryOrderKids="closeOrderKidsHistoryGroupDialog()"
        ref="OrderKidsHistoryGroupDialog"
    />

    <ExcelKidForGroupDetailDialog
        :isOpenKidDetail="isDialog.showKidDetailGroupDialog"
        :kids-detail-data="kidDetailData"
        @closeDetailKid="handleCloseDetailKidGroup"
        ref="ExcelKidDetailGroup"
    />

    <InventoryOrderForGroupDialog
        :isOpenInventoryOrder="isDialog.showInventoryOrderGroup"
        @closeInventoryOrder="closeInventoryOrderGroupDialog()"
        ref="InventoryOrderGroupDialog"
    />

    <CollectedMoneyForGroupDialog
        v-if="checkPermission(['fees_2_excel_cash_payment'])"
        :isOpenCollectedMoney="isDialog.showCollectedMoneyGroup"
        @closeCollectedMoney="closeCollectedMoneyGroupDialog()"
        ref="CollectedMoneyDialogForGroup"
    />

    <DetailKTForGroupDialog
        :isOpenDetailKT="isDialog.showDetailKTGroupDialog"
        @closeDetailKT="closeDetailKTGroupDialog()"
        ref="DetailKTForGroupDialog"
    />
  </div>
</template>

<script>
import {mapState} from "vuex";
import OrderKidsExcelCashier from "@/components/FinanceVer2/ByClass/ExcelTableDialog/OrderKidsExcelCashier.vue";
import HistoryOrderKidsDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/HistoryOrderKidsDialog.vue";
import DetailKTDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/DetailKTDialog.vue";
import checkPermission from "@/utils/permission";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import ExcelKidDetail from "@/components/FinanceVer2/ByClass/ExcelTableDialog/ExcelKidDetailDialog.vue";
import InventoryOrderDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/InventoryOrderDialog.vue";
import CollectedMoneyDialog from "@/components/FinanceVer2/ByClass/ExcelTableDialog/CollectedMoneyDialog.vue";
import tableValidateMixin from "@/global/mixin/tableValidate.mixin";
import countColumnActionMixin from "@/global/mixin/countColumnAction.mixin";
import operationPackage from "@/services/PackageService/OperationPackage";
import OrderKidsExcelCashierGroup
  from "@/components/FinanceVer2/ByGroup/GroupExcelTableDialog/OrderKidsExcelCashierGroup.vue";
import HistoryOderKidsDialogGroup
  from "@/components/FinanceVer2/ByGroup/GroupExcelTableDialog/HistoryOderKidsDialogGroup.vue";
import ExcelKidForGroupDetailDialog
  from "@/components/FinanceVer2/ByGroup/TableSearchGroupDialog/ExcelKidForGroupDetailDialog.vue";
import InventoryOrderForGroupDialog
  from "@/components/FinanceVer2/ByGroup/GroupExcelTableDialog/InventoryOrderForGroupDialog.vue";
import CollectedMoneyForGroupDialog
  from "@/components/FinanceVer2/ByGroup/GroupExcelTableDialog/CollectedMoneyForGroupDialog.vue";
import DetailKTForGroupDialog from "@/components/FinanceVer2/ByGroup/GroupExcelTableDialog/DetailKTForGroupDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

const props = {
  tab: "",
};

const headerCellStyle = ({columnIndex, column}) => {
  if (columnIndex >= 20 && column.label !== "Tác vụ") {
    return {
      backgroundColor: "#ea580cb3",
      color: "#fff",
    };
  }
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}

export default {
  components: {
    OrderKidsExcelCashier,
    HistoryOrderKidsDialog,
    DetailKTDialog,
    ExcelKidDetail,
    InventoryOrderDialog,
    CollectedMoneyDialog,
    OrderKidsExcelCashierGroup,
    HistoryOderKidsDialogGroup,
    ExcelKidForGroupDetailDialog,
    InventoryOrderForGroupDialog,
    CollectedMoneyForGroupDialog,
    DetailKTForGroupDialog,
  },
  props: props,
  computed: {
    ...mapState("packageStore", [
      "responseDataStudents",
      "isLoading",
    ]),
    courseNames() {
      const courses = new Set();
      this.responseDataStudents.forEach(student => {
        student.listKt.forEach(course => {
          if (!course.name.includes('Khoản thu')) {
            courses.add(course.name);
          }
        });
      });
      return Array.from(courses);
    },
  },
  data() {
    return {
      isDialog: {
        // Cho lớp
        showOrderKidsExcelCashierDialog: false,
        showHistoryDialog: false,
        showDetailKtDialog: false,
        showKidDetailDialog: false,
        showInventoryOrder: false,
        showCollectedMoney: false,

        // Cho nhóm
        showOrderKidsExcelCashierGroupDialog: false,
        showHistoryGroupDialog: false,
        showKidDetailGroupDialog: false,
        showInventoryOrderGroup: false,
        showCollectedMoneyGroup: false,
        showDetailKTGroupDialog: false,
      },
      isActivatedAccount: false,
      showOrHidden: {
        idOrder: "",
        idKid: "",
        month: "",
        status: false,
      },

      showListForApp: {
        date: "",
        idKidList: [],
        collectionTurn: "",
      },
      kidDetailData: {},
    }
  },
  mixins: [tableValidateMixin, countColumnActionMixin],
  created() {
    this.$parent.$on('resetTable', this.resetSelection);
  },
  methods: {
    checkPermission,
    headerCellStyle,

    handelShowOrHidden(row, value) {
      this.showOrHidden.month = row.orderMonth;
      this.showOrHidden.idKid = row.id_kid;
      this.showOrHidden.idOrder = row.id;
      this.showOrHidden.status = value;
      if(row.orderHidden){
        this.showOrHidden.status =true;
        this.$store.commit("packageStore/set_show_app_message", row.fullName);
      }
      else{
        this.showOrHidden.status =false
        this.$store.commit("packageStore/set_hidden_app_message", row.fullName);

      }
      financeKidsV2Service
          .showOrHiddenPackage(this.showOrHidden)
          .then((res) => {
            return this.$message({
              showClose: true,
              message: res.data.message,
              type: "success",
            });

          })
          .catch(() => {
            return this.$message({
              showClose: true,
              message: `Lỗi hệ thống `,
              type: "danger",
            });
          });
    },

    getStatusValue(status) {
      return status !== null ? status : "Chưa có hóa đơn";
    },

    getStatusColor(status) {
      if (status === null) {
        return "status-red";
      } else if (status === "Chưa đóng 100%" || status === "Chưa đóng đủ") {
        return "status-orange";
      } else if (status === "Đóng đủ 100%" || status === "Đóng thừa") {
        return "status-blue";
      } else {
        return "";
      }
    },

    /**
     * Mở dialog hiển thị tiền đã thu
     */
    collectedMoneyMethod(row, status) {
      this.isDialog.showCollectedMoney = !this.isDialog.showCollectedMoney;
      this.$refs.CollectedMoneyDialog.getCollectedMoney(
          row.orderMonth,
          row.id_kid,
          row.collectionTurn,
          status,
          row.createdYear
      );
    },

    getDetailKT(index, row, columnName, status) {
      this.isDialog.showDetailKtDialog = !this.isDialog.showDetailKtDialog;
      this.$refs.DetailKTDialog.showDetailKTPackage(
          index,
          row.managerTuitionId,
          row.orderMonth,
          row.kidCode,
          row.collectionTurn,
          columnName,
          status,
          row.createdYear
      );
    },

    showDataListKt(row, columnLabel) {
      const data = row.listKt.find(item => item.name === columnLabel);
      return data?.money;
    },

    getDataIndexKt(row, columnLabel) {
      const data = row.listKt.find(item => item.name === columnLabel);
      return data?.index;
    },

    closeOrderKidsExcelCashierDialog() {
      this.isDialog.showOrderKidsExcelCashierDialog = false;
    },

    /**
     * Mở dialog lưu lịch sử thanh toán lớp
     * @param row
     */
    orderKidsCashierMethod(row) {
      let idKid = row.id_kid;
      let kidCode = row.kidCode;
      let kidName = row.fullName;
      let orderKidCode = row.orderKidCode;
      let month = row.orderMonth;
      let year = row.createdYear;
      let activeStatus = row.activeStatus;

      let collectionTurn = row.collectionTurn;
      this.isDialog.showOrderKidsExcelCashierDialog = true;
      this.$refs.OrderKidsExcelCashier.getDataCashierInitial(
          idKid,
          kidCode,
          kidName,
          month,
          collectionTurn,
          orderKidCode,
          year,
          activeStatus
      );
      this.isActivatedAccount = row.fatherPhone !== "" || row.motherPhone !== "";
    },

    /**
     * Mở dialog hiển thị lịch sử thanh toán
     * @param row
     */
    orderKidsHistoryMethod(row) {
      this.isDialog.showHistoryDialog = true;
      this.$refs.OrderKidsHistoryDialog.getOrderHistoryInitial(
          row.id_kid,
          row.orderMonth,
          row.collectionTurn,
          row.createdYear
      );
    },

    handleOpenKidDetail(row, statusOrder) {
      this.isDialog.showKidDetailDialog = true;
      this.$refs.ExcelKidDetail.getInfoByMonthAndTurn(
          row.orderMonth,
          row.id_kid,
          row.collectionTurn,
          statusOrder,
          row.createdYear,
          row.tuitionStatus
      );
    },

    /**
     * Mở tồn hoá đơn cho lớp
     * @param row
     * */
    inventoryOrder(row) {
      const currentMonth = this.getCurrentMonth();
      this.isDialog.showInventoryOrder = true;
      this.$refs.InventoryOrderDialog.getInventoryOrderPackage(
          row.kidCode,
          row.fullName,
          row.id_kid,
          currentMonth,
          row.idGrade,
          row.idClass,
          row.createdYear
      );
    },

    closeOrderKidsHistoryDialog() {
      this.isDialog.showHistoryDialog = false;
      // this.$store.commit('packageStore/get_status_excel')
    },

    getButtonCashierType(row) {
      if (row.status === "Đóng đủ 100%" || row.status === "Đóng đủ thừa" || row.status === "Đóng đủ thiếu") {
        return 'info';
      }
      return 'primary';
    },

    closeDetailKTDialog(boolean) {
      this.isDialog.showDetailKtDialog = boolean;
    },

    handleCloseDetailKid(close) {
      this.isDialog.showKidDetailDialog = close;
    },

    closeInventoryOrderDialog(boolean) {
      this.isDialog.showInventoryOrder = boolean;
      this.$emit("resetDataFilter")
    },

    closeCollectedMoneyDialog(value) {
      this.isDialog.showCollectedMoney = false;
      this.$store.dispatch("packageStore/updateDataBeforePayment", value);
    },

    handleSelectionChange(val) {
      this.multipleSelection = val; // val laf 1 array object
      // this.listNullBillKids = [];
      // this.listHiddenOrder = []
      this.listShowForApp = []
      this.listHiddenForApp = []
      this.multipleSelection.forEach((row) => {
        // if (this.validateNullBillStudent(row)) {
        //   this.listNullBillKids = [...this.listNullBillKids, row.fullName];
        // }
        if (this.validateHiddenOrder(row)) {
          this.listHiddenOrder = [...this.listHiddenOrder, row.fullName]; // lấy danh sách bị ẩn
        }
        if (row.orderHidden) {
          this.listShowForApp = [...this.listShowForApp, row.fullName]// lấy danh sách hiển thị lên app
        }
        if (!row.orderHidden) {
          this.listHiddenForApp = [...this.listHiddenForApp, row.fullName]// lấy danh sách không hiện thị lên app
        }
      });
      // quản lý danh sách null
      this.$store.commit(
          "packageStore/set_hidden_order_kids",
          this.listHiddenOrder
      );
      this.$store.commit(
          "packageStore/set_show_for_app",
          this.listShowForApp
      );
      this.$store.commit(
          "packageStore/set_hidden_for_app",
          this.listHiddenForApp
      );
      this.$store.commit(
          "packageStore/set_null_bill_kids",
          this.listNullBillKids
      );
      // eslint-disable-next-line no-unused-vars
      let multipleSelectionCopy = this.multipleSelection;
      let idKidList = [];
      let managerTuitionId = []
      let listKidsRequest = []
      multipleSelectionCopy = multipleSelectionCopy.map((item) => {
        let obj = {
          idKid: item.id_kid,
          managerTuitionId: item.managerTuitionId,
          fullName: item.fullName,
          month: item.orderMonth,
          year: item.createdYear,
          sumMoney: item.sumMoney,
          afterMoney: item.afterMoney,
          startDate: item.startDate,
          endDate: item.endDate
        }
        idKidList = [...idKidList, item.id_kid];
        managerTuitionId = [...managerTuitionId, item.managerTuitionId];
        listKidsRequest = [...listKidsRequest, obj];
      });
      this.$store.commit("packageStore/set_id_kid_list", idKidList);
      this.$store.commit("packageStore/set_manager_tuition_id", managerTuitionId);
      this.$store.commit("packageStore/set_list_kids_request", listKidsRequest);
    },

    formatDateTime(dateString) {
      const [year, month, day] = dateString.split("-");

      return `${day}/${month}/${year}`;
    },

    handelRegisterPackage(row, boolean) {
      const data = {
        idManagerTuition: row.managerTuitionId,
        idSchool: "",
        checkStatus: !boolean,
      }

      operationPackage.extendPackage(data)
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "success",
            });
          })
          .catch((err) => {
            console.log(err.message);
          })
    },

    resetSelection() {
      this.$refs.tableStudent.clearSelection();
    },

    /**
     * Mở dialog lưu lịch sử thanh toán nhóm
     * @param row
     */
    orderKidsCashierGroupMethod(row) {
      let idKid = row.id_kid;
      let kidCode = row.kidCode;
      let kidName = row.fullName;
      let orderKidCode = row.orderKidCode;
      let month = row.orderMonth;
      let year = row.createdYear;
      let idGroup = row.idGroup;

      let collectionTurn = row.collectionTurn;
      this.isDialog.showOrderKidsExcelCashierGroupDialog = true;
      this.$refs.OrderKidsExcelCashierGroup.getDataCashierInitialForGroup(
          idKid,
          kidCode,
          kidName,
          month,
          collectionTurn,
          orderKidCode,
          year,
          idGroup
      );
      this.isActivatedAccount = row.fatherPhone !== "" || row.motherPhone !== "";
    },

    closeOrderKidsExcelCashierGroupDialog() {
      this.isDialog.showOrderKidsExcelCashierGroupDialog = false;
    },

    /**
     * Mở dialog hiển thị lịch sử thanh toán
     * @param row
     */
    orderKidsHistoryGroupMethod(row) {
      this.isDialog.showHistoryGroupDialog = true;
      this.$refs.OrderKidsHistoryGroupDialog.getOrderHistoryInitial(
          row.id_kid,
          row.orderMonth,
          row.collectionTurn,
          row.createdYear,
          row.idGroup
      );
    },

    closeOrderKidsHistoryGroupDialog() {
      this.isDialog.showHistoryGroupDialog = false;
    },

    /**
     * Mở dialog hiển thị thông tin bổ sung cho nhóm
     * */
    handleOpenKidGroupDetail(row, statusOrder) {
      this.isDialog.showKidDetailGroupDialog = true;
      this.$refs.ExcelKidDetailGroup.getInfoByMonthAndTurn(
          row.orderMonth,
          row.id_kid,
          row.collectionTurn,
          statusOrder,
          row.createdYear,
          row.idGroup,
          row.tuitionStatus
      );
    },

    handleCloseDetailKidGroup() {
      this.isDialog.showKidDetailGroupDialog = false;
    },

    inventoryOrderGroup(row) {
      const currentMonth = this.getCurrentMonth();
      this.isDialog.showInventoryOrderGroup = true;
      this.$refs.InventoryOrderGroupDialog.getInventoryOrderPackage(
          row.kidCode,
          row.fullName,
          row.id_kid,
          row.idGroup,
          currentMonth,
          row.createdYear,
      );
    },

    closeInventoryOrderGroupDialog() {
      this.showInventoryOrder = false;
      this.$emit("resetDataFilter")
    },

    /**
     * Mở dialog hiển thị tiền đã thu
     */
    collectedMoneyGroupMethod(row, status) {
      this.isDialog.showCollectedMoneyGroup = true;
      this.$refs.CollectedMoneyDialogForGroup.getCollectedMoney(
          row.orderMonth,
          row.id_kid,
          row.collectionTurn,
          status,
          row.createdYear,
          row.idGroup
      );
    },

    closeCollectedMoneyGroupDialog(value) {
      this.isDialog.showCollectedMoneyGroup = false;
      this.$store.dispatch("packageStore/updateDataBeforePayment", value);
    },

    /**
     * Mở dialog hiển thị chi tiết khoản thu
     */
    getDetailKTGroup(index, row, nameKt, statusOrder) {
      if (row.onlinePaymentSuccessful === true){
        NotifyMessage.leftCornerNotificationWarning("Hóa đơn đã được thanh toán trực tuyến thành công lên không thể sửa đổi!")
      } else {
        this.isDialog.showDetailKTGroupDialog = !this.isDialog.showDetailKTGroupDialog;
        this.$refs.DetailKTForGroupDialog.showDetailKTPackage(
            index,
            row.managerTuitionId,
            row.orderMonth,
            row.kidCode,
            row.collectionTurn,
            nameKt,
            statusOrder,
            row.createdYear,
            row.idGroup
        );
      }

    },

    closeDetailKTGroupDialog(boolean) {
      this.isDialog.showDetailKTGroupDialog = boolean;
    },

    getCurrentMonth() {
      const today = new Date();

      return today.getMonth() + 1;
    },

    getSummaries({ columns, data }) {
      const toNumber = (val) => {
        if (typeof val === 'number') return val;
        if (val == null) return 0;
        // loại bỏ định dạng tiền tệ / dấu phân cách nếu lỡ là string
        const s = String(val).replace(/[^\d\-.]/g, '');
        const n = Number(s);
        return Number.isFinite(n) ? n : 0;
      };

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 13) {
          sums[index] = 'Tổng cộng';
          return;
        }

        const total = data.reduce((acc, row) => {
          // Có property: cộng trực tiếp từ row[prop]
          if (column.property) {
            return acc + toNumber(row[column.property]);
          }
          // Không có property: là cột sinh động -> cộng theo label
          if (column.label) {
            // showDataListKt phải sẵn có trong component methods
            const v = this.showDataListKt(row, column.label);
            return acc + toNumber(v);
          }
          return acc;
        }, 0);

        // Nếu total = 0 nhưng thực sự cột là text, để rỗng
        sums[index] =
            total > 0
                ? total.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
                : '';
      });

      return sums;
    },


  },
}
</script>

<style lang="scss" scoped>
.menu-main {
  min-height: 950px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 210px;
  min-height: 700px;
  font-family: Arial, serif;
}

.router-link {
  text-decoration: none;
}

.el-menu-item {
  background-color: #1f2d3d !important;
}

.el-menu-item:hover {
  background-color: #49575f !important;
}

/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}

.el-menu {
  margin-bottom: 20px;
}

.onekids-title {
  font-weight: bold;
}

/* Định nghĩa các lớp màu sắc */
.status-red {
  color: red;
}

.status-orange {
  color: orange;
}

.status-blue {
  color: blue;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 2px 0;
}

/deep/ .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #FFF;
}

span.el-tooltip {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
/deep/ .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}

/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}
</style>